import { Color, Paragraph } from '@eggplant/pattern-library'

const ScriptedGlobalParamsDescription = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Global parameter are shared across all test cases within a script-based tests config. Once they are defined you can then use them as your custom parameter values.
    </Color>
  </Paragraph>

export default ScriptedGlobalParamsDescription
